import { Button, Typography } from 'antd'
import React, { useContext } from 'react'

import createOperation from './operations/MarketingOperationCreate'
import createAudience from './audience/MarketingAudienceCreate'
import showAudience from './audience/MarketingAudienceShow'

export default function MarketingEmpty({isOperation, contextValue, onSave}) {
   
   const {diAppRef} = contextValue

   const onClick = () => {
      if (isOperation === true) {
         createOperation({context:contextValue, onSave:onSave})
      } else {
         createAudience({context:contextValue, onSave:onSave})
      }
   }

  return (
      <div className='di-no-content-wrapper'>
         <Typography className='fs-16'>
            {isOperation ? "Sembra che tu non abbia ancora fatto operazioni..." : "Ops... Sembra che non ci sia ancora alcun pubblico"}
        </Typography>
        <div className='flex flex-wrap gap-10 align-center justify-center mt-20 mb-20'>
           
            <Button
               className='px-30 mw-100 fw-5'
               ref={diAppRef.refAudienceCreate}
               onClick={onClick}
               type={"primary"}
               size='large'
            >
                  + Crea {isOperation ? "Operazione" : "Pubblico"}
           </Button>
           
           {!isOperation &&
            <Button
               className='px-30 mw-100 fw-5'
               ref={diAppRef.refAudienceShow}
               onClick={()=>showAudience({context:contextValue},)}
               size='large'
            >
                  Mostra tutti gli utenti
            </Button>
           }
       </div>
      </div>
  )
}
